import React, { useState } from 'react';
import {Copy} from 'lucide-react'
import styled from 'styled-components';
import SyntaxHighlighter from 'react-syntax-highlighter/dist/esm/prism-async-light';
import { oneLight } from 'react-syntax-highlighter/dist/esm/styles/prism';
import python from 'react-syntax-highlighter/dist/esm/languages/prism/python';
SyntaxHighlighter.registerLanguage('python', python);
import { breakpoints } from '@/layouts/breakpoints';

const StyledComp = styled.div`
  background-size: cover;
  padding: 60px 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 400px;
  opacity:1;
  transition-duration: 0.2s;
  width: calc(100% - 80px);
  position: relative;
  &:before{
    position: absolute;
    content: '';
    top: 50%;
    transform: translateY(-50%);
    left: 0;
    width: 100%;
    height: 100%;
    min-height: 100vh;
    background-size: cover;
    background-image: ${props => (props.$bg) ? 'url(/code/' + props.$bg + ')' : ''};
    z-index: -1;

  }

  @media (max-width: 768px) {
    &:before{
      height: 100%;
      min-height: 0px;
      top: 0%;
      transform: unset;

    }

    @media (max-width: ${breakpoints.small}) {
      padding: 20px;
      width: calc(100% - 40px);
    }

  }

  .code-window {
    background: rgb(250,250,250);
    border-radius: 12px;
    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.25);
    width: 100%;
    max-width: 640px;
    overflow: hidden;
  }
  .code-window-titlebar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 14px 18px;
    background: #f7f7f7;
    border-bottom: 1px solid #e8e8e8;
  }

  .traffic-lights {
    display: flex;
    gap: 7px;
    @media (max-width: ${breakpoints.small}) {
      display: none;
    }
  }
  .traffic-light {
    width: 12px;
    height: 12px;
    border-radius: 50%;
  }
  .tl-red    { background: #ff5f57; }
  .tl-yellow { background: #febc2e; }
  .tl-green  { background: #28c840; }
  .code-window-filename {
    font-size: 12px;
    color: #888;
    font-family: 'Menlo', 'Monaco', 'Consolas', monospace;
  }
  .code-window-copy {
    display: flex;
    align-items: center;
    gap: 5px;
    font-size: 12px;
    color: #999;
    cursor: pointer;
    background: none;
    border: none;
    padding: 0;
    transition: color 0.15s;
  }
  .code-window-copy:hover {
    color: #555;
  }
  .code-window-body {
    padding: 20px 22px;
    background: rgb(250,250,250);
    min-height: 240px;
  }
  .code-window-body pre {
    margin: 0 !important;
    padding: 0 !important;
    background: transparent !important;
    font-size: 13.5px !important;
    line-height: 1.65 !important;
    font-family: 'Menlo', 'Monaco', 'Consolas', monospace !important;
  }

  /* ── Desktop: side-by-side layout ── */
  @media (min-width: 1024px) {
    .hero-desktop-wrapper {
      display: flex;
      align-items: stretch;
      min-height: 100vh;
    }

    /* Left column: copy */
    .hero-copy-col {
      flex: 0 0 420px;
      display: flex;
      flex-direction: column;
      justify-content: center;
    }
    .hero {
      padding: 80px 48px;
      padding-top: 80px;
    }
    .hero h1 {
      font-size: 44px;
      width: 640px;
    }

    /* Right column: tabs + demo */
    .hero-demo-col {
      flex: 1;
      display: flex;
      flex-direction: column;
      min-width: 0;
    }
    .tabs {
      flex-shrink: 0;
      margin-top: 200px;
    }
    .demo-area {
      flex: 1;
      min-height: 0;
    }
  }
`;


const CodeWindow = ({ filename, code, bg }) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = () => {
    navigator.clipboard.writeText(code);
    setCopied(true);
    setTimeout(() => setCopied(false), 1500);
  };
  return <StyledComp $bg={bg}>
    <div className="code-window">
      <div className="code-window-titlebar">
        <div className="traffic-lights">
          <div className="traffic-light tl-red" />
          <div className="traffic-light tl-yellow" />
          <div className="traffic-light tl-green" />
        </div>
        <span className="code-window-filename">{filename}</span>
        <button className="code-window-copy" onClick={handleCopy}>
          <Copy width={14}/>
          {copied ? 'Copied!' : 'Copy'}
        </button>
      </div>
      <div className="code-window-body">
        <SyntaxHighlighter
          style={oneLight}
          language={'python'}
        >
          {code}
        </SyntaxHighlighter>
      </div>
    </div>
  </StyledComp>

};


export default CodeWindow;
